import { Component, OnInit, Input } from '@angular/core';
import { Settings } from '../../services/settings';
import { TransactionHistory } from '../../models/transaction-history';
import { AppComponent } from '../../app.component';


@Component({
	selector: 'app-transaction-history-minimal',
	templateUrl: './transaction-history-minimal.component.html',
	styleUrls: ['./transaction-history-minimal.component.css']
})
export class TransactionHistoryMinimalComponent implements OnInit {

	dataHistory: any;
	selectedRow: any;
	cols: any;
	loading = false;
	eventSubscriptions: any[];
	_regEntryId: number;
	_scrollHeight = '565px';
	
	@Input() set scrollHeight(value: any) {
		this._scrollHeight = value+'px';
		if(value===675){
			this._scrollHeight = 'calc(100vh - 250px)'
		}
	}

	get scrollHeight(): string {
		return this._scrollHeight;
	}
	
	@Input() set regEntryId(value: number) {
		this._regEntryId = value;
		if (value === undefined || value <= 0 ) {
			return;
		} else {
			this.onShowHandler('RegisterEntries', value);
		}
	}

	get regEntryId(): number {
		return this._regEntryId;
	}
	
	constructor() { }

	ngOnInit(): void {
		this.cols = [
			{ field: 'transaction_date', header: 'Date', width: '25%', labelFunction: Settings.dateLabelFunction },
			//  { field: 'transaction_date', header: 'Time', width: '10%', labelFunction: Settings.timeLabelFunction },
			{ field: 'user_uid', header: 'By', width: '25%' },
			{ field: 'tx_action', header: 'Details', width: '50%' },
			{ field: 'old_value', header: 'Old Value', width: '20%' },
			{ field: 'new_value', header: 'New Value', width: '20%' },
		];
	}
	public onShowHandler(source: string, regEntryId: number) {
		if (regEntryId === undefined || regEntryId === null || regEntryId <1) {
			return;
		}
		this.loading = true;
	}
	public loadInvoiceHistory(id: any) {
		this.loading = true;
	}
}
